import React, { useState, useEffect } from "react";
import { Container, Navbar, Nav, Offcanvas } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import "./header.css";

const Header = () => {
  const [show, setShow] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div>
      <Navbar
        expand="lg"
        fixed="top"
        className={`stl-navbar ${scrolled ? "navbar-scrolled" : ""}`}
      >
        <Container fluid="xxl">
          <Navbar.Brand as={Link} to="/">
            <motion.img
              whileHover={{ scale: 1.05 }}
              src="./images/starlight-logo.png"
              alt="logo"
              className="logo"
            />
          </Navbar.Brand>

          <button className="mobile-menu-btn" onClick={() => setShow(true)}>
            <HiOutlineMenuAlt3 />
          </button>

          <Navbar.Collapse className="justify-content-end d-none d-lg-flex">
            <Nav className="align-items-center">
              {/* <NavLink to="/" className="nav-link-custom">
                Home
              </NavLink> */}

              <NavLink to="/about" className="nav-link-custom">
                About Us
              </NavLink>

              <NavLink to="/boutique" className="nav-link-custom">
                Boutique IT VC
              </NavLink>

              <NavLink to="/product-development" className="nav-link-custom">
                Product Development Studio
              </NavLink>

              <NavLink to="/gtm-guru" className="nav-link-custom">
                GTM Guru
              </NavLink>

              <NavLink to="/consulting" className="nav-link-custom">
                IT Business Consulting
              </NavLink>

              <NavLink to="/contact" className="nav-link-custom">
                Contact
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* MOBILE MENU */}

      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        placement="end"
        className="mobile-offcanvas"
      >
        <Offcanvas.Header>
          <div className="mobile-logo">STL</div>

          <button className="close-btn" onClick={() => setShow(false)}>
            <IoClose />
          </button>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <motion.div
            initial={{ x: 80, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.4 }}
          >
            <Nav className="flex-column">
              {/* <NavLink className="mobile-nav-link" to="/">
                Home
              </NavLink> */}

              <NavLink className="mobile-nav-link" to="/about">
                About Us
              </NavLink>

              <NavLink className="mobile-nav-link" to="/boutique">
                Boutique IT VC
              </NavLink>

              <NavLink className="mobile-nav-link" to="/product-development">
                Product Development Studio
              </NavLink>

              <NavLink className="mobile-nav-link" to="/gtm-guru">
                GTM Guru
              </NavLink>

              <NavLink className="mobile-nav-link" to="/consulting">
                IT Business Consulting
              </NavLink>

              <NavLink className="mobile-nav-link" to="/contact">
                Contact Us
              </NavLink>
            </Nav>
          </motion.div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Header;
